module.exports = __webpack_public_path__ + "img/9788901070445.69e1f62b.jpg";